<template>
  <div>
    <Mainl @mlogin="mlogin" @scrollTo="scrollTo"></Mainl>
    <!--  // V3.0版本页面样式
    <div class="page_content">
      <div class="table_wrap"  v-show="tableData.length > 0">
        <el-table
          :data="tableData"
          tooltip-effect="light"
          style="width: 100%"
          header-row-class-name="table_header"
          header-cell-class-name="table_header_tr"
          class="creative_table"
        >
          <el-table-column prop="SerialNumber" label="序号" width="80">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" width="204" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="OrderMoney" label="含税总价" width="136" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.OrderStatus == 1 || scope.row.OrderStatus == 5">{{scope.row.OrderMoney != 0 ? (scope.row.OrderMoney + Number.EPSILON).toFixed(2) : '-'}}</span>
              <span v-else>{{scope.row.OrderMoney != 0 ? (scope.row.OrderMoney + Number.EPSILON).toFixed(2) : '0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="订单状态" width="120">
            <template slot-scope="scope">
              <span :class="`status_${statusMap[scope.row.OrderStatus]}`">{{statusMapDesc[scope.row.OrderStatus]}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="OrderNum" label="订单编号" width="148" show-overflow-tooltip>
          </el-table-column>
          <el-table-column  label="下单时间" align="center" width="136">
            <div class="order_table_date" slot-scope="scope">
              <span v-show="scope.row.CreateTime == 0">-</span>
              <span v-show="scope.row.CreateTime != 0">{{scope.row.CreateTimeStr.slice(0, 10)}}</span>
              <span v-show="scope.row.CreateTime != 0">{{scope.row.CreateTimeStr.slice(scope.row.CreateTimeStr.length - 8, scope.row.CreateTimeStr.length)}}</span>
            </div>
          </el-table-column>
          <el-table-column prop="name" label="确认时间" align="center"  width="136">
            <div class="order_table_date" slot-scope="scope">
              <span v-show="scope.row.ConfirmTime == 0">-</span>
              <span v-show="scope.row.ConfirmTime != 0">{{scope.row.ConfirmTimeStr.slice(0, 10)}}</span>
              <span v-show="scope.row.ConfirmTime != 0">{{scope.row.ConfirmTimeStr.slice(scope.row.ConfirmTimeStr.length - 8, scope.row.ConfirmTimeStr.length)}}</span>
            </div>
          </el-table-column>
          <el-table-column prop="name" label="完成时间" align="center"  width="136">
            <div class="order_table_date" slot-scope="scope">
              <span v-show="scope.row.CompleteTime == 0">-</span>
              <span v-show="scope.row.CompleteTime != 0">{{scope.row.CompleteTimeStr.slice(0, 10)}}</span>
              <span v-show="scope.row.CompleteTime != 0">{{scope.row.CompleteTimeStr.slice(scope.row.CompleteTimeStr.length - 8, scope.row.CompleteTimeStr.length)}}</span>
            </div>
          </el-table-column>

          <el-table-column label="操作" header-align="center">
            <div class="order_table_operate" slot-scope="scope">
              <el-button type="text" @click="goDetail(scope.row.OrderId)">详情</el-button>
              <el-button v-if="scope.row.OrderStatus === 1"  @click="orderStatusBox(scope.row.OrderId, 5)" type="text">取消</el-button>
              <el-button v-if="scope.row.OrderStatus === 2"  @click="orderStatusBox(scope.row.OrderId, 3)" type="text">确认</el-button>
              <el-button v-if="scope.row.OrderStatus === 3"  @click="orderStatusBox(scope.row.OrderId, 4)" type="text">完成</el-button>
            </div>
          </el-table-column>
        </el-table>
      </div>

      <div class="empty_page" v-show="tableData.length == 0">
        <img :src="require('@/assets/img/my_order_empty.png')"/>
        <p>暂无订单</p>
      </div>
      <el-dialog
        :visible.sync="cancelVisible"
        width="360px"
        custom-class="my_order_modal"
        title="确定要取消订单吗？"
        @close="closeBox"
      >
        <p class="detail">订单取消后无法还原，如有需要请重新下单</p>
        <footer style="background-image: inherit; height: auto; padding-top: inherit; display: -webkit-box;">
          <el-button
            class="modal_content_btn_submit"
            @click="cancelVisible = false"
          >取消</el-button
          >
          <el-button class="modal_content_btn_submit" type="primary" @click="updStatus"
          >确定</el-button
          >
        </footer>
      </el-dialog>
      <el-dialog
        :visible.sync="confirmVisible"
        width="360px"
        custom-class="my_order_modal"
        title="订单确认后无法取消，是否确认？"
        @close="closeBox"
      >
        <p class="detail">
          确认将表示您知情且同意星云与您在线下沟通的全部内容，确认后订单将开始服务。订单确认后无法取消，是否确认？
        </p>
        <footer style="background-image: inherit; height: auto; padding-top: inherit; display: -webkit-box;">
          <el-button
            class="modal_content_btn_submit"
            @click="confirmVisible = false"
          >取消</el-button
          >
          <el-button class="modal_content_btn_submit" type="primary"  @click="updStatus"
          >确定</el-button
          >
        </footer>
      </el-dialog>
      <el-dialog
        :visible.sync="completeVisible"
        width="360px"
        custom-class="my_order_modal"
        title="确定要完成订单吗？"
        @close="closeBox"
      >
        <p class="detail"></p>
        <footer style="background-image: inherit; height: auto; padding-top: inherit; display: -webkit-box;">
          <el-button
            class="modal_content_btn_submit"
            @click="completeVisible = false">取消</el-button>
          <el-button class="modal_content_btn_submit" type="primary" @click="updStatus">确定</el-button>
        </footer>
      </el-dialog>
    </div>
    -->
    <!-- // v4.0版本页面样式 -->
    <div class="page_content">
      <div class="my-project-content">
        <div class="my-project-tabs">
          <el-radio-group class="my-project-tabs-group" v-model="tabType" @change="initList()">
            <el-radio-button label="1">待执行（{{ tabTypeOrderNum.toBeExecuted }}）</el-radio-button>
            <el-radio-button label="2">执行中（{{ tabTypeOrderNum.inExecution }}）</el-radio-button>
            <el-radio-button label="3">已完成（{{ tabTypeOrderNum.done }}）</el-radio-button>
            <el-radio-button label="4">已取消（{{ tabTypeOrderNum.cancelled }}）</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 待执行 -->
        <div v-show="tabType == 1" class="my_project_implement">
          <el-table :data="tableData" style="width: 100%" class="order_table" header-row-class-name="my-header-row-class">
            <el-table-column width="360" prop="id" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">{{ scope.row.requirement }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="create_time_str" label="下单时间" align="center"> </el-table-column>
            <el-table-column prop="order_status" align="center" label="订单状态">
              <template slot-scope="scope">
                <span class="implement_tag" v-if="scope.row.order_status == 4">待执行</span>
                <span class="candidate_tag" v-if="scope.row.order_status == 3">待选择</span>
                <span class="order_tag" v-if="scope.row.order_status == 2 || scope.row.order_status == 1">待接单</span>
              </template>
            </el-table-column>
            <el-table-column prop="service_company" label="服务商名称" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_service company_arr_list">
                  <span v-for="(item, key) in scope.row.company_arr" :key="key">
                    <el-badge is-dot class="item" v-if="item.file_is_change == 1">
                      <el-button type="text" @click="showServiceInfo(item, scope.row.order_status)">{{item.service_company}}</el-button>
                    </el-badge>
                    <el-button v-else type="text" @click="showServiceInfo(item, scope.row.order_status)">{{item.service_company}}</el-button>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="操作" width="148" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_operation">
                  <el-popover placement="top" width="240"  :ref="'popover' + scope.row.order_id" :visible.sync="visibleIndex" @after-leave="checkServicePopoverLeave">
                    <div class="popover_content">
                      <el-select style="width: 240px;" v-model="serviceInfo.serviceUserId" placeholder="请选择">
                        <el-option v-for="item in serviceSelectOptions" :key="item.service_userid" :label="item.service_company" :value="item.service_userid">
                        </el-option>
                      </el-select>
                      <p>选择服务商后无法更换，请仔细选择</p>
                    </div>

                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="popoverCancel()">取消</el-button>
                      <el-button type="primary" size="mini" @click="checkServicePopoverConfirm(scope.row)">确定</el-button>
                    </div>
                    <el-button style="padding: 5px 0;" slot="reference" type="text" @click="popoverCheckService(scope.row)" v-if="scope.row.order_status == 3">选择服务商</el-button>
                  </el-popover>
                  <el-button type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
                  <el-popover placement="top" width="240" :key="scope.row.order_id" :ref="'popover' + scope.row.order_id" :visible.sync="visibleIndex" @after-leave="popoverLeave">
                    <div class="popover_content">
                      <el-input v-model="cancelReason" style="width: 240px;" placeholder="请输入取消原因"></el-input>
                      <p>订单取消后无法还原，如需请重新下单</p>
                    </div>

                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text"  @click="popoverCancel()">取消</el-button>
                      <el-button type="primary" size="mini" @click="orderCancelPopoverConfirm(scope.row, 8)">确定</el-button>
                    </div>
                    <el-button style="padding: 5px 0;color:#6D6E74" slot="reference" type="text" v-if="scope.row.order_status != 4">取消</el-button>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog custom-class="my_project_demand_modal" :title="'服务商：' + serviceInfo.serviceCompany" :visible.sync="serviceInfoVisible" width="680px" :before-close="handleClose2" :close-on-click-modal="false">
          <div class="my_project_demand_modal_list">
            <img v-if="serviceInfo.orderFiles.length == 0 && serviceInfo.orderCases.length == 0" :src="require('@/assets/img/shopping_cart_empty.png')"/>
            <p style="text-align: center" v-if="serviceInfo.orderFiles.length == 0 && serviceInfo.orderCases.length == 0">该服务商还没有关联任何案例或附件～</p>

            <div class="my_project_demand_modal_list_title" v-show="serviceInfo.orderFiles.length > 0">
              相关附件：
            </div>
            <el-table :data="serviceInfo.orderFiles" border style="width: 100%" class="my_project_demand_modal_table"  v-show="serviceInfo.orderFiles.length > 0">
              <el-table-column prop="filename" label="附件名称" align="center">
                <template slot-scope="scope">
                  <div class="my_project_implement_table_service">
                    <el-button type="text" @click="seeOrderFile(scope.row)">{{scope.row.filename}}</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="annex_desc" label="附件说明" align="center"> </el-table-column>
              <el-table-column prop="datetime" label="上传时间" align="center"> </el-table-column>
            </el-table>
            <div class="my_project_demand_modal_list_title" v-show="serviceInfo.orderCases.length > 0">
              关联案例：
            </div>
            <div class="my_project_demand_modal_list_wrap" v-show="serviceInfo.orderCases.length > 0">
              <!-- :class="index === 0 && 'my_project_demand_modal_list_item_select'" -->
              <div v-for="(item,index) in serviceInfo.orderCases" class="my_project_demand_modal_list_item" title="点击查看案例详情" :key="index" @click="seeCaseDetail(item)">
                <img :src="item.case_cover" />
                <div class="my_project_demand_modal_list_item_info">
                  <div class="my_project_demand_modal_list_item_info_name">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                      <span style="overflow: hidden; max-width: 180px; height: 22px; white-space: nowrap; text-overflow: ellipsis;">{{ item.name }}</span>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="item.category_top_name" placement="bottom">
                      <span class="my_project_demand_modal_list_item_info_tag" style="overflow: hidden; max-width: 80px; height: 22px; white-space: nowrap; text-overflow: ellipsis;">{{ item.category_top_name }}</span>
                    </el-tooltip>
                  </div>
                  <div class="my_project_demand_modal_list_item_info_type">
                    {{ item.category_second_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="my_project_demand_modal_footer">
            <span v-show="serviceInfo.orderStatus != 4">选择服务商后无法更换</span>
            <el-button style="width: 104px;height: 40px;" class="my_project_demand_card_btn_2" type="primary" @click="checkService()" v-show="serviceInfo.orderStatus != 4">选择他</el-button>
          </div>
        </el-dialog>
        <!-- 执行中 -->
        <div v-show="tabType == 2" class="my_project_implement">
          <el-table :data="tableData" style="width: 100%" class="order_table" header-row-class-name="my-header-row-class">
            <el-table-column width="360" prop="project_name" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">{{ scope.row.requirement }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="execution_time_str" label="执行开始时间" align="center"> </el-table-column>
            <el-table-column prop="service_company" label="服务商名称" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_service">
                  <b v-for="(item, key) in scope.row.company_arr" :key="key">{{item.service_company}}</b>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="order_money" label="含税总价" align="center"> </el-table-column>
            <el-table-column prop="create_time_str" label="下单时间" align="center"> </el-table-column>
            <el-table-column prop="count" label="操作" width="148" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 已完成 -->
        <div v-show="tabType == 3" class="my_project_implement">
          <el-table :data="tableData" style="width: 100%" class="order_table">
            <el-table-column width="360" prop="id" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">{{ scope.row.requirement }}</p>
              </template>
            </el-table-column>

            <el-table-column prop="name" align="center" label="订单状态">
              <template slot-scope="scope">
                <span class="complete_tag" v-if="scope.row.order_status == 7">已完成</span>
                <span class="accept_tag" v-if="scope.row.order_status == 6">待验收</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="服务商名称" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_service">
                  <b v-for="(item, key) in scope.row.company_arr" :key="key">{{item.service_company}}</b>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="order_money" label="含税总价" align="center"> </el-table-column>
            <el-table-column prop="complete_time_str" label="完成时间" align="center"> </el-table-column>
            <el-table-column prop="count" label="操作" width="148" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_operation">
                  <el-button type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
                  <!--
                  <el-button type="text" v-if="scope.row.order_status == 6" @click="completeOrder(scope.row.order_id, 7)">完成2</el-button>
                  -->

                  <el-popover placement="top" width="240" :key="scope.row.order_id" :ref="'popover' + scope.row.order_id" :visible.sync="visibleIndex" @after-leave="popoverLeave">
                    <div class="popover_content">
                      <p>您是否已经验收交付物并确定订单已服务完成？</p>
                    </div>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text"  @click="popoverCancel()">取消</el-button>
                      <el-button type="primary" size="mini" @click="completeOrder(scope.row.order_id, 7)">确定</el-button>
                    </div>
                    <el-button style="padding: 5px 0;" slot="reference" type="text" v-if="scope.row.order_status == 6">完成</el-button>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 已取消 -->
        <div v-show="tabType == 4" class="my_project_implement">
          <el-table :data="tableData" style="width: 100%" class="order_table">
            <el-table-column width="360" prop="id" label="项目名称">
              <template slot-scope="scope">
                <div class="my_project_implement_table_name">{{ scope.row.project_name }}</div>
                <p class="my_project_implement_table_desc margin0 multi-text2">{{ scope.row.requirement }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="服务商名称" align="center">
              <template slot-scope="scope">
                <div class="my_project_implement_table_service">
                  <b v-for="(item, key) in scope.row.company_arr" :key="key">{{item.service_company}}</b>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="order_money" label="含税总价" align="center"> </el-table-column>
            <el-table-column prop="cancel_time_str" label="取消时间" align="center"> </el-table-column>
            <el-table-column prop="cancel_reason" label="取消原因" align="center"> </el-table-column>
            <el-table-column prop="count" label="操作" width="148" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="goDetail(scope.row.order_id)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
import * as commfun from '@/common/common.js'
var pubPrefix = '/api'
export default {
  name: 'Order',
  components: {
    Mainl
  },
  data: function () {
    // status progress进行中  allocated 待分配 confirmed待确认 cancel取消  complete完成
    return {
      statusMapDesc: {
        1: '待分配',
        2: '待确认',
        3: '进行中',
        4: '已完成',
        5: '已取消'
      },
      statusMap: {
        1: 'allocated',
        2: 'confirmed',
        3: 'progress',
        4: 'complete',
        5: 'cancel'
      },
      cancelVisible: false, // 取消
      confirmVisible: false, // 确认
      completeVisible: false, // 完成
      tableData: [],
      orderId: 0,
      orderStatus: 0,
      subFlag: true,

      tabType: 1,  // 页签
      tabTypeOrderNum: {
        toBeExecuted: 0,  // 待执行
        inExecution: 0,  // 执行中
        done: 0,  // 已完成
        cancelled: 0  // 已取消
      },
      serviceInfo: {
        serviceCompany: '', // 服务商公司名
        serviceUserId: '',
        orderStatus: '',
        orderId: '',
        orderFiles: [],  // 关联附件
        orderCases: []   // 关联案例
      },
      serviceInfoVisible: false,
      visibleIndex: false,
      cancelReason: '',  // 取消原因
      serviceSelectOptions: [],
    }
  },
  mounted () {
    this.initList()
  },
  methods: {
    // 列表数据
    initList: function () {
      var selfthis = this
      var url = pubPrefix + '/api/order/demandOrderList'
      var postdata = {tabType: this.tabType}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        if (data.orderData == null || data.orderData === undefined) {
          selfthis.tableData = []
        } else {
          // 1）已完成订单tab展示订单状态为【待验收】和已完成的订单，待验收的订单展示在已完成订单的上面，即展示完所有待验收订单之后再展示已完成订单。
          // 2）其中待验收订单按照执行完成时间正序排序，已完成订单按照完成时间倒序排序。
          if (selfthis.tabType == 3) {
            let orderedData = data.orderData
            orderedData.sort((a, b) => {
              if (a.order_status !== b.order_status) {
                return a.order_status - b.order_status;
              } else if (a.execute_complete_time !== b.execute_complete_time) {
                return a.execute_complete_time - b.execute_complete_time;
              } else {
                return b.complete_time - a.complete_time;
              }
            });
            selfthis.tableData = orderedData
          } else {
            selfthis.tableData = data.orderData
          }
          selfthis.tabTypeOrderNum = data.tabTypeData
        }
        selfthis.subFlag = true
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 详情页
    goDetail (orderId) {
      window.open('/orderdetail?order_id=' + orderId)
    },
    // 订单状态弹框
    orderStatusBox (orderId, orderStatus) {
      this.cancelVisible = false
      this.completeVisible = false
      this.confirmVisible = false
      if (orderStatus === 5) { // 取消
        this.cancelVisible = true
      } else if (orderStatus === 4) { // 完成
        this.completeVisible = true
      } else if (orderStatus === 3) { // 确认
        this.confirmVisible = true
      }
      this.orderId = orderId
      this.orderStatus = orderStatus
    },
    // 关闭弹框
    closeBox () {
      this.cancelVisible = false
      this.completeVisible = false
      this.confirmVisible = false
      this.orderId = 0
      this.orderStatus = 0
      this.subFlag = true
    },
    // 更新订单状态
    updStatus () {
      if (!this.subFlag) {
        return
      }
      this.subFlag = false
      if (this.orderId !== 0 && this.orderStatus !== 0) {
        var selfthis = this
        var url = pubPrefix + '/api/order/renewStatus'
        var postdata = {order_id: this.orderId, order_status: this.orderStatus}
        commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
          // 完成
          if (selfthis.orderStatus == 7) {
            commfun.showMessage(selfthis, 'success', "订单已完成！")
          }
          // 重新获取列表
          selfthis.initList()
          selfthis.closeBox()
          selfthis.popoverCancel()
        }, function (selfthis, dataError) {
          commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
        })
      }
    },
    mlogin: function (type) {
      if (type === 'example') {
        this.visible = true
      } else {
        this.visible2 = true
      }
    },
    scrollTo: function (type) { // 滚动到位置 锚点
      document.querySelector('#' + type).scrollIntoView(true)
    },

    handleClose2(done) {
      this.serviceInfoVisible = false
      this.serviceInfo.orderStatus = ''
    },
    // 查看服务商信息
    showServiceInfo (item, order_status) {
      var selfthis = this
      selfthis.serviceInfo.serviceCompany = item.service_company
      selfthis.serviceInfo.serviceUserId = item.service_userid
      selfthis.serviceInfo.orderId = item.order_id
      selfthis.serviceInfo.orderStatus = order_status
      selfthis.serviceInfoVisible = true
      // 查询服务方案例和附件
      var url = pubPrefix + '/api/order_material/getOrderMaterial'
      var postdata = {service_userid: item.service_userid, order_id: item.order_id}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        selfthis.serviceInfo.orderFiles = data.annexData
        selfthis.serviceInfo.orderCases = data.caseData
        // 去掉红点
        if (item.file_is_change == 1) {
          item.file_is_change = 0
        }
      }, function (selfthis, dataError) {
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 查看文件
    seeOrderFile (item) {
      if (item.url) {
        window.open(item.url)
      }
    },
    // 案例详情
    seeCaseDetail (item) {
      window.open('/casedetail?id=' + item.case_id + '&jump_from=1')
    },
    // 选择服务商
    checkService () {
      var selfthis = this
      if (!this.subFlag) {
        return
      }
      this.subFlag = false
      if (selfthis.serviceInfo.serviceUserId == '' || selfthis.serviceInfo.orderId == '') {
        return
      }
      var url = pubPrefix + '/api/order/demandCheckService'
      var postdata = {service_userid: selfthis.serviceInfo.serviceUserId, order_id: selfthis.serviceInfo.orderId}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        commfun.showMessage(selfthis, 'success', "选择服务商成功！")
        selfthis.serviceInfoVisible = false
        selfthis.initList()
        document.body.click()
      }, function (selfthis, dataError) {
        selfthis.subFlag = true
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 处理取消订单确认操作
    orderCancelPopoverConfirm(item, orderStatus) {
      var selfthis = this
      var cancelReason = this.cancelReason.trim()
      if (cancelReason == '') {
        commfun.showMessage(selfthis, 'warning', '请填写取消原因！')
        return
      }
      if (cancelReason.length > 10) {
        commfun.showMessage(selfthis, 'warning', '取消原因最长10个字符！')
        return
      }
      if (!this.subFlag) {
        return
      }
      this.subFlag = false
      // 修改订单状态为取消
      var url = pubPrefix + '/api/order/renewStatus'
      var postdata = {order_status: orderStatus, order_id: item.order_id, cancelReason: cancelReason}
      commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
        document.body.click()
        selfthis.initList()
      }, function (selfthis, dataError) {
        selfthis.subFlag = true
        commfun.showMessage(selfthis, 'warning', '错误：' + dataError.msg)
      })
    },
    // 气泡框消失
    popoverLeave () {
      this.cancelReason = ''
      this.subFlag = true
      this.orderStatus = 0
      this.orderId = 0
    },
    // 处理取消操作
    popoverCancel() {
      document.body.click()
      this.cancelReason = ''
      this.subFlag = true
      this.orderStatus = 0
      this.orderId = 0
    },
    // 气泡框选择服务商
    popoverCheckService (item) {
      this.serviceSelectOptions = item.company_arr
      this.serviceInfo.orderId = item.order_id
    },
    // 气泡框确认选择服务商
    checkServicePopoverConfirm (item) {
      this.checkService()
    },
    // 气泡框消失
    checkServicePopoverLeave () {
      this.serviceInfo.orderId = ''
      this.serviceInfo.serviceUserId = ''
      this.subFlag = true
    },
    // 完成订单
    completeOrder (orderId, orderStatus) {
      this.orderId = orderId
      this.orderStatus = orderStatus
      this.updStatus()
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Order.vue